import { render, staticRenderFns } from "./estate-iframe-section.vue?vue&type=template&id=67cff334&scoped=true&"
import script from "./estate-iframe-section.vue?vue&type=script&lang=js&"
export * from "./estate-iframe-section.vue?vue&type=script&lang=js&"
import style0 from "./estate-iframe-section.vue?vue&type=style&index=0&id=67cff334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cff334",
  null
  
)

export default component.exports